import type { FaireProductEntity } from "../../entity_types/product";

export const p_s9cymaks9h: FaireProductEntity = {
  token: "p_s9cymaks9h",
  type: "product",
  name: "Carlos The Cold Cactus: Written & Illustrated by - Hardcover",
  brandToken: "b_4d6jvdz5w2",
  brandName: "Books by splitShops",
  imageUrl:
    "https://cdn.faire.com/fastly/44973201fbb4921411c1e28409cd660f599f217331dedd6da0744b81d026a0c1.jpeg",
  galleryImageUrls: [],
  priceDollars: 29.88,
  description:
    "by Sarah Hauer (Author)\n\nIn in the Sonoran Desert of Arizona, lives Carlos and Bella. Neighbors on the same saguaro cactus. Bella is a happy saguaro flower and Carlos is grumpy and always cold Bella with the help of her desert friends, takes Carlos on a wild adventure to Alaska, where he really does learn what it is to be cold. He ends up learning even more about friendships and neighbors.\nNumber of Pages: 36 Dimensions: 0.25 x 11 x 8.5 IN Publication Date: July 03, 2020",
  tags: [],
  msrpDollars: 37.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:56.025Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
